import React, {useEffect, useState} from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Grid, TextField, Typography} from "@mui/material";
import ButtonGroup from '@mui/material/ButtonGroup';
import {useNavigate, useSearchParams} from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, useTheme} from '@mui/material/styles';
import Button from '@mui/material/Button';
import {setCookie} from '../utils/Functions';
import './Home.css';

const ASSETS = process.env.REACT_APP_URL_CONFIG + "/assets/imgs/unicef/teleton2026";

function genRandonString() {
    var chars = '123456789';
    var charLength = chars.length;
    var result1 = '';
    for (var i = 0; i < 6; i++) {
        result1 += chars.charAt(Math.floor(Math.random() * charLength));
    }
    var chars2 = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var charLength2 = chars2.length;
    var result2 = '';
    for (var i = 0; i < 5; i++) {
        result2 += chars2.charAt(Math.floor(Math.random() * charLength2));
    }
    var chars3 = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var charLength3 = chars3.length;
    var result3 = '';
    for (var i = 0; i < 6; i++) {
        result3 += chars3.charAt(Math.floor(Math.random() * charLength3));
    }
    return result1 + result2 + result3;
}

const ColorButton = styled(Button)(({theme}) => ({
    color: theme.palette.getContrastText("#000"),
    fontSize: 20,
    fontWeight: "700",
    padding: 1,
    height: 65,
    borderRadius: 3,
    width: "100%",
    backgroundColor: "#f8632c",
    '&:hover': {
        backgroundColor: "#f8632c",
    },
}));

var fieldType = "hidden";

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState("");
    const [amount, setAmount] = useState(120);
    const [monto, setMonto] = useState("");

    const [searchParams] = useSearchParams();
    const [finalData, setFinalData] = useState({
        monto: "120",
        texto: "",
        amount: "",
        trxuuid: genRandonString(),
        utm_source: searchParams.get("utm_source") || "false",
        utm_medium: searchParams.get("utm_medium") || "false",
        utm_campaign: searchParams.get("utm_campaign") || "false",
        utm_id: searchParams.get("utm_id") || "false",
        utm_term: searchParams.get("utm_term") || "false",
        utm_content: searchParams.get("utm_content") || "false",
    });

    useEffect(() => {
        let _finalData = {...finalData};
        const params = ["utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content"];
        params.forEach(param => {
            if (searchParams.get(param)) {
                _finalData[param] = searchParams.get(param);
                setCookie(process.env.REACT_APP_NAME + param, searchParams.get(param), 0.1);
            }
        });
        setTimeout(() => setFinalData(_finalData), 100);
    }, []);

    const handleChange = (event) => {
        if (event.target.value === "") {
            setAmount(event.target.value);
        } else {
            if (/^[0-9]+$/.test(event.target.value)) {
                setError("");
                setAmount(event.target.value);
                if (event.key === 'Enter') {
                    donate(event);
                }
            }
        }
    };

    const donate = () => {
        if (parseInt(amount) >= 60) {
            finalData["monto"] = amount + "";
            finalData["amount"] = amount + "";
            setTimeout(() => {
                document.getElementById("formCyber").submit();
            }, 100);
        } else {
            setError("El monto debe ser mayor a Bs 60");
        }
    };

    const scrollToDonation = () => {
        document.getElementById("donation-form").scrollIntoView({behavior: "smooth"});
    };

    return (
        <div className="teleton-home">
            {/* Hero Section */}
            <section className="teleton-hero">
                <img
                    src={`${ASSETS}/portada.png`}
                    alt="Teleton 2026"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'top center'
                    }}
                />
                <div style={{position: 'relative', zIndex: 2, width: '100%', height: fullScreen ? '70vh' : '85vh'}} />
            </section>

            {/* Donation Form */}
            <div className="donation-form" id="donation-form">
                <form id="formCyber" action="https://pdp.unicef.org.bo/public/formulario22" method="post">
                    <input type={fieldType} name="_token" value="dRcbRPGC0d0Wr8btDNMkpMhyJp4bMlrDHCpwnCRN"/>
                    <input type={fieldType} name="_token" value="dRcbRPGC0d0Wr8btDNMkpMhyJp4bMlrDHCpwnCRN"/>
                    <input type={fieldType} name="access_key" value="b07eaab29f8f3c03987860013cf9cb80"/>
                    <input type={fieldType} name="profile_id" value="FAD45E5D-7004-4962-BD59-AB4B3A36C431"/>
                    <input type={fieldType} name="transaction_uuid" value={finalData.trxuuid}/>
                    <input type={fieldType} name="monto" value={showAmount ? "texto" : amount}/>
                    <input type={fieldType} name="texto" value={showAmount ? amount : ""}/>
                    <input type={fieldType} name="amount" value={amount}/>
                    <input type={fieldType} name="utm_source" value={finalData.utm_source}/>
                    <input type={fieldType} name="utm_medium" value={finalData.utm_medium}/>
                    <input type={fieldType} name="utm_campaign" value={finalData.utm_campaign}/>
                    <input type={fieldType} name="utm_id" value={finalData.utm_id}/>
                    <input type={fieldType} name="utm_term" value={finalData.utm_term}/>
                    <input type={fieldType} name="utm_content" value={finalData.utm_content}/>
                    <input type={fieldType} name="sourceid" value="UNICEF"/>
                    <input type={fieldType} name="merchant_defined_data97" value="Transaccion+unica"/>

                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <Typography
                                sx={{mb: {xs: 4, md: 3, lg: 2}, mt: {xs: 4, md: 3, lg: 2}}}
                                variant={fullScreen ? "h3" : "h4"}
                                style={{textAlign: "center", color: fullScreen ? "#009ce0" : "#fff"}}>
                                Selecciona tu donación mensual
                            </Typography>
                        </Grid>

                        <Grid item lg={3} xs={3}>
                            <ColorButton className={amount === 120 ? "donate-button-active" : "donate-button"} style={{
                                textTransform: "capitalize",
                                border: "2px solid #fff",
                                backgroundColor: amount === 120 ? "#009ce0" : "transparent"
                            }} onClick={() => {
                                setError("");
                                setAmount(120);
                                setMonto("");
                                setShowAmount(false);
                            }} variant="contained">Bs 120</ColorButton>
                        </Grid>

                        <Grid item lg={3} xs={3}>
                            <ColorButton className={amount === 90 ? "donate-button-active" : "donate-button"} style={{
                                textTransform: "capitalize",
                                border: "2px solid #fff",
                                backgroundColor: amount === 90 ? "#009ce0" : "transparent"
                            }} onClick={() => {
                                setError("");
                                setAmount(90);
                                setMonto("");
                                setShowAmount(false);
                            }} variant="contained">Bs 90</ColorButton>
                        </Grid>

                        <Grid item lg={3} xs={3}>
                            <ColorButton className={amount === 60 ? "donate-button-active" : "donate-button"} style={{
                                textTransform: "capitalize",
                                border: "2px solid #fff",
                                backgroundColor: amount === 60 ? "#009ce0" : "transparent"
                            }} onClick={() => {
                                setError("");
                                setAmount(60);
                                setMonto("");
                                setShowAmount(false);
                            }} variant="contained">Bs 60</ColorButton>
                        </Grid>

                        <Grid item lg={3} xs={3}>
                            <ColorButton
                                className={amount !== 120 && amount !== 90 && amount !== 60 ? "donate-button-active" : "donate-button"}
                                style={{
                                    textTransform: "capitalize",
                                    border: "2px solid #fff",
                                    backgroundColor: amount !== 120 && amount !== 90 && amount !== 60 ? "#009ce0" : "transparent"
                                }} onClick={() => {
                                setAmount("");
                                setShowAmount(true);
                                setMonto("texto");
                            }} variant="contained">Otro</ColorButton>
                        </Grid>

                        <Grid item lg={12} xs={12}
                              sx={{mb: {xs: 4, md: 3, lg: 2}, mt: {xs: 4, md: 2, lg: 1}}}>
                            <div>
                                <h6 style={{padding: 4}}>*** No olvides activar tu tarjeta para compras por
                                    internet</h6>
                            </div>
                        </Grid>

                        <Grid item lg={12} xs={12} mt={1} style={{textAlign: "center"}}>
                            {showAmount ?
                                <ButtonGroup
                                    style={{width: "100%"}}
                                    disableElevation
                                    variant="contained"
                                    aria-label="Disabled elevation buttons"
                                >
                                    <TextField style={{width: "50%"}}
                                               className="amount-text"
                                               value={amount}
                                               onChange={handleChange}
                                               onKeyDown={handleChange}
                                    />
                                    <ColorButton onClick={donate} style={{width: "50%"}}>Dona Ahora</ColorButton>
                                </ButtonGroup>
                                :
                                <ColorButton style={{borderRadius: 35, width: fullScreen ? "50%" : "100%"}}
                                             onClick={donate}>Dona Ahora</ColorButton>
                            }
                        </Grid>

                        {error !== "" &&
                            <Grid item lg={12} xs={12} mt={1}>
                                <div style={{
                                    background: "#000",
                                    zIndex: "99",
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    color: "#fff",
                                    padding: 5,
                                    borderRadius: 5
                                }}>
                                    <WarningAmberIcon variant="h6" sx={{fontSize: "2rem", marginRight: 1}}/>
                                    {error}
                                </div>
                            </Grid>
                        }
                    </Grid>
                </form>
            </div>

            {/* Problem Section */}
            <section className="teleton-problem">
                <img
                    src={`${ASSETS}/problema.png`}
                    alt="4 de cada 10 niños"
                    className="teleton-problem__image"
                    style={{width: '100%', maxWidth: 800}}
                />
            </section>

            {/* Prizes Section */}
            <section className="teleton-prizes">
                <img
                    src={`${ASSETS}/heart-light.png`}
                    alt=""
                    className="teleton-prizes__bg-heart"
                    aria-hidden="true"
                />
                <img
                    src={`${ASSETS}/premios.png`}
                    alt="Premios del sorteo"
                    className="teleton-prizes__image"
                />
                <div style={{marginTop: 30}}>
                    <button className="teleton-cta-btn" onClick={scrollToDonation}>
                        DONA AHORA
                    </button>
                </div>
            </section>

            {/* Water / Rural Section */}
            <section className="teleton-water">
                <img
                    src={`${ASSETS}/datos.png`}
                    alt="4 de cada 10 familias sin agua potable"
                    style={{width: '100%'}}
                />
            </section>

            {/* Impact Areas */}
            <section className="teleton-impact">
                <h2 className="teleton-impact__title">
                    Todo lo recaudado contribuirá a fortalecer <span className="highlight">cuatro áreas prioritarias</span> de trabajo de UNICEF en Bolivia
                </h2>
                <img
                    src={`${ASSETS}/recaudado.png`}
                    alt="Áreas prioritarias"
                    style={{width: '100%', maxWidth: 500, margin: '0 auto', display: 'block'}}
                />
            </section>

            {/* Final CTA */}
            <section className="teleton-final-cta">
                <button className="teleton-cta-btn" onClick={scrollToDonation}>
                    DONA AHORA
                </button>
            </section>

            {/* Sponsors */}
            <section className="teleton-sponsors">
                <p className="teleton-sponsors__title">Con el apoyo de:</p>
                <img
                    src={`${ASSETS}/sponsors.png`}
                    alt="Patrocinadores"
                    className="teleton-sponsors__image"
                />
            </section>
        </div>
    );
};

Home.propTypes = {};

export default Home;
